import React, { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom';
import Cookies from "js-cookie";
import { toast } from 'sonner';
import { useMediaQuery } from 'usehooks-ts';

const Header = () => {
  const navigate=useNavigate()
  const location=useLocation()
 
  const token = Cookies.get("roam-token");

const mobile = useMediaQuery("(max-width: 767px)");


    const handleScroll = (id) => {
    const section = document.getElementById(id);
    if (section) {
      section.scrollIntoView({ behavior: "smooth", block: "start" });
    }
    console.log(location.pathname);
    
  };


  return (
     <header className="header" style={{zIndex:1000,height:"70px"}}>
      <div className="header-container" style={{display:"flex",justifyContent:"space-between",width:"100%",padding:mobile?"14px":"5px"}}>
        <div className="logo" onClick={() =>{location.pathname!=="/payment"?navigate("/"):toast.warning('Complete the booking process!')}}
          style={{display:"flex",alignItems:"center",gap:"10px",paddingLeft:mobile?"2px":"20px"}}
          >
         {!mobile && <img src="/Assets/title-logo.png" style={{width:"40px",height:"36px"}}/>}
          <img src="/Assets/logo.png" style={{width:"100%",height:mobile?"29px":"27px"}}/>
        </div>

      {!mobile? <div>{location.pathname==="/" && !mobile? <ul className="nav-menu">
          <li href="#" className="nav-link" onClick={() => handleScroll("booking")}>Book a bus</li>
          <li href="#" className="nav-link" onClick={() => handleScroll("about")}>About Us</li>
          <li href="#" className="nav-link" onClick={() => handleScroll("workings")}>How it works?</li>
          <li href="#" className="nav-link" onClick={() => handleScroll("deals")}>Special Deal</li>
        </ul>
        :
         <ul className="nav-menu">
          {/* <li href="#" className="nav-link" onClick={() => handleScroll("booking")}>Bus Booking</li>
          <li href="#" className="nav-link" onClick={() => handleScroll("about")}>Seat Selection</li>
          <li href="#" className="nav-link" onClick={() => handleScroll("workings")}></li>
          <li href="#" className="nav-link" onClick={() => handleScroll("deals")}>Special Deal</li> */}
        </ul>
        }</div>:""}

       <div style={{paddingRight:mobile?"2px":"20px"}}>
        {!token? <div className="header-actions">
          <button className="sign-in-btn"onClick={()=>navigate("/login")} style={{fontSize:mobile?"14px":""}}>Sign in</button>
          <button className="register-btn" onClick={()=>navigate("/login")} style={{fontSize:mobile?"14px":""}}>Register</button>
        </div>
        :
         <div className="header-actions">
          <button className="register-btn"style={{fontSize:mobile?"14px":""}}
          onClick={()=>{location.pathname!=="/payment"?navigate("/myprofile"):toast.warning('Complete the booking process!')}}>Account</button>
         </div>}
         </div>
      </div>
    </header>
  )
}

export default Header
